import {
  Dropdown,
} from 'react-overlays';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';

import Toggle from './components/Toggle';
import Menu from './components/Menu';
import ButtonTypes from '../../constants/buttonTypes';

function CustomDropdownMenu({
  drop, btnText,
  Icon, btnType, btnStyle,
  role, headerText, children,
  indicator, containerStyle,
  show, alignEnd, onToggle, headerComponent,
  mainContainerStyle, usePortal, mobileDrop
}) {
  const [isMobile, setIsMobile] = useState(() => (
    typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches
  ));

  useEffect(() => {
    const media = window.matchMedia('(max-width: 767px)');
    const onChange = (event) => setIsMobile(event.matches);

    setIsMobile(media.matches);
    media.addEventListener('change', onChange);

    return () => media.removeEventListener('change', onChange);
  }, []);

  const responsiveDrop = isMobile && mobileDrop ? mobileDrop : drop;
  const menuContent = (
    <div className="fixed w-max max-w-[calc(100vw-24px)] z-[3000]">
      <Menu
        role={role}
        headerText={headerText}
        containerStyle={containerStyle}
        mainContainerStyle={mainContainerStyle}
        mobile={isMobile}
      >
        {children}
      </Menu>
    </div>
  );
  return (
    <Dropdown
      show={show}
      onToggle={onToggle}
      drop={responsiveDrop}
      alignEnd={alignEnd}
      itemSelector="button:not(:disabled)"
      defaultShow={false}
      focusFirstItemOnShow={false}
    >
      <div>
        <Toggle
          btnText={btnText}
          Icon={Icon}
          btnType={btnType}
          btnStyle={btnStyle}
          indicator={indicator}
          headerComponent={headerComponent}
        />
        {usePortal && typeof document !== 'undefined'
          ? createPortal(menuContent, document.body)
          : menuContent}
      </div>
    </Dropdown>
  );
}

CustomDropdownMenu.propTypes = {
  children: PropTypes.node.isRequired,
  headerComponent: PropTypes.node,
  Icon: PropTypes.shape({}),
  drop: PropTypes.oneOf(['up', 'down', 'left', 'right']),
  btnText: PropTypes.string,
  btnType: PropTypes.string,
  headerText: PropTypes.string,
  indicator: PropTypes.bool,
  show: PropTypes.bool,
  alignEnd: PropTypes.bool,
  btnStyle: PropTypes.string,
  containerStyle: PropTypes.string,
  mainContainerStyle: PropTypes.string,
  usePortal: PropTypes.bool,
  mobileDrop: PropTypes.oneOf(['up', 'down', 'left', 'right']),
  role: PropTypes.string,
  onToggle: PropTypes.func
};

CustomDropdownMenu.defaultProps = {
  drop: 'left',
  Icon: null,
  btnText: '',
  btnType: ButtonTypes.LIGHT_PRIMARY,
  headerText: undefined,
  indicator: false,
  show: undefined,
  alignEnd: undefined,
  btnStyle: undefined,
  containerStyle: undefined,
  mainContainerStyle: undefined,
  usePortal: false,
  mobileDrop: undefined,
  role: undefined,
  onToggle: undefined,
  headerComponent: undefined
};

export default CustomDropdownMenu;
